export function formatNumber({ no, style = 'currency', currency = "USD" }: { no: number, style?: string; currency?: string; }) {
    console.log(currency,"cuurecny")
    return new Intl.NumberFormat('en-US', { style, currency }).format(no);
}
